import { Modal } from 'antd';

// eslint-disable-next-line import/prefer-default-export
const Alert = (title, content, type, options = {}) => {
  Modal[type]({
    className: options.hideFooter ? 'no-alertify-buttons' : '',
    title,
    content,
    centered: true,
    okText: options.okText || 'Ok',
    onOk: options.onOk,
    closable: options.closable,
    cancelText: options.cancelText || 'Close',
    onCancel: options.onCancel,
    okButtonProps: {
      style: {
        backgroundColor: '#B299F2'
      }
    }

    // icon: options.icon,
  });
};

export default Alert;
